var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 9.16667C12.0392 9.16667 11.6667 9.54 11.6667 10C11.6667 10.9192 10.9192 11.6667 10 11.6667C9.08083 11.6667 8.33333 10.9192 8.33333 10C8.33333 9.54 7.96083 9.16667 7.5 9.16667C7.03917 9.16667 6.66667 9.54 6.66667 10C6.66667 11.8383 8.16167 13.3333 10 13.3333C11.8383 13.3333 13.3333 11.8383 13.3333 10C13.3333 9.54 12.9608 9.16667 12.5 9.16667ZM15 15.8333H5C4.54 15.8333 4.16667 15.4592 4.16667 15V7.5H15.8333V15C15.8333 15.4592 15.46 15.8333 15 15.8333ZM6.7675 4.41083C6.92333 4.25583 7.1375 4.16667 7.35667 4.16667H12.6433C12.8625 4.16667 13.0767 4.25583 13.2325 4.41083L14.655 5.83333H5.345L6.7675 4.41083ZM16.7675 5.58917L14.4108 3.2325C13.9392 2.76 13.3108 2.5 12.6433 2.5H7.35667C6.68917 2.5 6.06083 2.76 5.58917 3.2325L3.2325 5.58917C2.76 6.06083 2.5 6.68917 2.5 7.3575V15C2.5 16.3783 3.62167 17.5 5 17.5H15C16.3783 17.5 17.5 16.3783 17.5 15V7.3575C17.5 6.68917 17.24 6.06083 16.7675 5.58917Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.ef938fa3648ea4f07f1a272070e559c1.svg";
export { ForwardRef as ReactComponent };